import { lazy } from 'react';
import Loadable from 'components/Loadable';

const RecruitmentDashboard = Loadable(lazy(() => import('./components/recruitment-dashboard/RecruitmentDashboard')));
const RecruitmentJobs = Loadable(lazy(() => import('./components/recruitment-jobs/RecruitmentJobs')));
const RecruitmentCandidates = Loadable(lazy(() => import('./components/recruitment-candidates/RecruitmentCandidates')));
const RecruitmentInterviews = Loadable(lazy(() => import('./components/recruitment-interviews/RecruitmentInterviews')));
const RecruitmentReports = Loadable(lazy(() => import('./components/recruitment-reports/RecruitmentReports')));

export const recruitmentRoutes = {
  path: 'recruitment',
  children: [
    { index: true, element: <RecruitmentDashboard /> },
    { path: 'dashboard', element: <RecruitmentDashboard /> },
    { path: 'jobs', element: <RecruitmentJobs /> },
    { path: 'candidates', element: <RecruitmentCandidates /> },
    { path: 'interviews', element: <RecruitmentInterviews /> },
    { path: 'reports', element: <RecruitmentReports /> }
  ]
};

export default recruitmentRoutes;
